'use es6';

import { createFetchImportNamesByObjectType, fetchImportNamesByObjectType } from '../api/ImportsAPI';
import * as CacheKeys from '../constants/CacheKeys';
import createSimpleCachedReferenceResolver from '../lib/createSimpleCachedReferenceResolver';
export const createInboundDbCompanyImportReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.INBOUND_DB_COMPANY_IMPORT,
  createFetchData: opts => {
    const getFn = createFetchImportNamesByObjectType(opts);
    return () => getFn('company');
  },
  fetchData: () => fetchImportNamesByObjectType('company')
}, options));
export default createInboundDbCompanyImportReferenceResolver();